// @flow

import React from 'react';
import type { Node } from 'react';
import { Heading } from '@riseart/common';
import { Wrapper } from '@riseart/layout';

import { artistHeaderCls } from 'shared_components/artist/header/Header.less';

type Props = {
  title: string,
  subtitle: string | Node,
  children?: ?Node,
};

/**
 * ArtistHeader
 */
export const ArtistHeader = ({ title, subtitle, children = null }: Props) => (
  <Wrapper className={artistHeaderCls}>
    <Heading tag="h1" level="1">
      {title}
      <span>{subtitle}</span>
    </Heading>
    {children}
  </Wrapper>
);
